import React from 'react';
import { useLanguage } from '../../../helpers/language-context';
import { renderHTML } from '../../../helpers/render-html';

// const LogoGuidelines = () => {
//   const { translations } = useLanguage();
//   return (
//     <section className="bg-[#F2F2F2] text-black space-y-8">
//         <div className="flex flex-col space-y-8 justify-center items-center mx-auto">
//             <div>
//                 <h2 className="text-[#28357B] text-4xl md:text-5xl lg:text-6xl" dangerouslySetInnerHTML={renderHTML(translations.about.logoGuidelines)} />
//             </div>
//             <div className="space-y-2 md:max-w-[80%]">
//                 <p className="text-xs" dangerouslySetInnerHTML={renderHTML(translations.about.logoGuidelinesDesc)} />
//             </div>
//       </div>
      
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//         <div>
//           <div className="bg-white p-4 rounded-md">
            
//           </div>
//           <div className="items-center justify-center flex p-4 rounded-md">
//             <p className="text-xs" dangerouslySetInnerHTML={renderHTML(translations.about.mainLogo)} />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

const LogoGuidelines = () => {
  const { translations } = useLanguage();

  return (
    <section className="bg-[#F2F2F2] text-black space-y-8">
      {/* Header Section */}
      <div className="flex flex-col space-y-8 justify-center items-center mx-auto">
        <div>
          <h2 className="text-[#28357B] text-4xl md:text-5xl lg:text-6xl" dangerouslySetInnerHTML={renderHTML(translations.about.logoGuidelines)} />
        </div>
        <div className="space-y-2 md:max-w-[80%]">
          <p className="text-xs" dangerouslySetInnerHTML={renderHTML(translations.about.logoGuidelinesDesc)} />
        </div>
      </div>

      {/* Three Column Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 md:auto-rows-min gap-8">
  
  {/* Main Logo Card - Desktop: Row 1 Col 1, Mobile: Position 1 */}
  <div className="md:col-start-1 md:row-start-1 bg-white rounded-2xl shadow-lg p-12 flex flex-col items-center justify-center">
    <img src="/assets/images/logo/logo-guidelines.png" alt="Blue Wave" className="w-48 h-auto" />
  </div>

  {/* Text 1 - Desktop: Row 2 Col 1, Mobile: Position 2 */}
  <div className="md:col-start-1 md:row-start-2 flex mb-4 md:mb-0 rounded-md justify-center">
    <div className="text-lg text-[#28357B]" dangerouslySetInnerHTML={renderHTML(translations.about.mainLogo)} />
  </div>

  {/* Colour Codes Card - Desktop: Row 1 Col 2, Mobile: Position 3 */}
  <div className="md:col-start-2 md:row-start-1 bg-white rounded-2xl shadow-lg p-12 flex flex-col">
    <div className="flex-1 flex flex-col justify-center space-y-8">
      {/* Navy Blue */}
      <div className="flex items-center space-x-4">
        <div className="w-10 h-10 rounded-full bg-blue-900 shadow-md"></div>
        <div>
          <span className="text-gray-400 font-medium">#28357B</span>
          <span className="text-gray-400"> - Hex</span>
        </div>
      </div>

      {/* Orange */}
      <div className="flex items-center space-x-4">
        <div className="w-10 h-10 rounded-full bg-orange-500 shadow-md"></div>
        <div>
          <span className="text-gray-400 font-medium">#F9A21E</span>
          <span className="text-gray-400"> - Hex</span>
        </div>
      </div>

      {/* Red */}
      <div className="flex items-center space-x-4">
        <div className="w-10 h-10 rounded-full bg-red-600 shadow-md"></div>
        <div>
          <span className="text-gray-400 font-medium">#D1212A</span>
          <span className="text-gray-400"> - Hex</span>
        </div>
      </div>
    </div>
  </div>

  {/* Text 2 - Desktop: Row 2 Col 2, Mobile: Position 4 */}
  <div className="md:col-start-2 md:row-start-2 flex mb-4 md:mb-0 rounded-md justify-center">
    <div className="text-lg text-[#28357B]" dangerouslySetInnerHTML={renderHTML(translations.about.colourCodes)} />
  </div>

  {/* Font Name Card - Desktop: Row 1 Col 3, Mobile: Position 5 */}
  <div className="md:col-start-3 md:row-start-1 bg-white rounded-2xl shadow-lg p-12 flex flex-col items-center justify-center">
    <div className="text-center">
      <div className="text-5xl sm:text-6xl lg:text-7xl text-gray-400 font-serif mb-2">K S S B</div>
      <div className="text-2xl text-gray-400 font-serif">Font Name</div>
    </div>
  </div>
  
  {/* Text 3 - Desktop: Row 2 Col 3, Mobile: Position 6 */}
  <div className="md:col-start-3 md:row-start-2 flex rounded-md justify-center">
    <div className="text-lg text-[#28357B]" dangerouslySetInnerHTML={renderHTML(translations.about.fontName)} />
  </div>
</div>
    </section>
  );
};

export default LogoGuidelines;